import { office, value, achievement, history } from "../../../shared/assets/img";

export const prideData = [
    {
        imageAttributes: { src: value },
        title: "Наши ценности",
        to: "/about/#values",
    },
    {
        imageAttributes: { src: achievement },
        title: "Наши достижения",
        to: "/about/#achievements",
    },
    {
        imageAttributes: { src: history },
        title: "Наша история",
        to: "/about/#history",
    },
    {
        imageAttributes: { src: office },
        title: "Наши офисы",
        to: "/about/#office",
    },
];
